module.exports = __webpack_public_path__ + "static/mikkabouzu777-b2bb8ea41f51de8a5c168238adbfe99d.jpg";